<template>
  <div :class="[$style.config, $style.wrap]">
    <div :class="$style.inner">
      <div :class="$style.header">
        <BaseHeading :class="$style.heading" size="h3">
          {{ localizedStrings['related-articles'] || 'Related Articles' }}
        </BaseHeading>

        <div :class="$style.cta">
          <BaseButton :to="`/news`">
            {{ localizedStrings['all-news'] || 'All News' }}
          </BaseButton>
        </div>
      </div>

      <div :class="$style.cards">
        <ArticleCard v-for="card in data" :key="card?.sys?.id" :data="card" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeArticleWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { localizedStrings } = useLocalizedStrings()

defineProps<{
  data: (TypeArticleWithoutUnresolvableLinksResponse | undefined)[] | undefined
}>()
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--related-articles-wrap-padding',
    (
      base: 50px 20px 57px,
      md: 64px 20px 76px,
    )
  );

  @include breakpoint-variables(
    '--related-articles-header-flex-direction',
    (
      base: column,
      md: row,
    )
  );

  @include breakpoint-variables(
    '--related-articles-header-text-align',
    (
      base: center,
      md: left,
    )
  );

  @include breakpoint-variables(
    '--related-articles-cards-grid-gap',
    (
      base: 17px,
      md: 27px,
    )
  );

  @include breakpoint-variables(
    '--related-articles-cards-grid-columns',
    (
      base: 1fr,
      md: repeat(3, 1fr),
    )
  );
}

.wrap {
  background-color: var(--gray-1);
  padding: var(--related-articles-wrap-padding);
}

.inner {
  max-width: var(--related-articles-container-max-width, 1200px);
  margin: 0 auto;
}

.header {
  margin-bottom: 15px;
  text-align: var(--related-articles-header-text-align);
  display: flex;
  flex-direction: var(--related-articles-header-flex-direction);
  justify-content: space-between;
  gap: 15px;
}

.cards {
  display: grid;
  gap: var(--related-articles-cards-grid-gap);
  grid-template-columns: var(--related-articles-cards-grid-columns);
}
</style>
